'use strict';

export default class Marketplace {
    constructor() {
        if ($(".menu--marketplace").length > 0) {
            var $cart_count = parseInt($('.cart-block--summary__count').text().replace(' items', ''));
            console.log('Cart counter' + $cart_count);
            if ($cart_count) {
                $('.menu--marketplace .menu-cart').append("<span class='count'>" + $cart_count + "</span>");
                $('.menu--marketplace .menu-cart').css('display', 'block');
            }
        }

       

    }
}
